import { FC, useEffect } from 'react';
import { useTranslations } from '@altermaind/core/i18n';
import { TutorialDialog } from '@/_shared/components';
import { TutorialKeys } from '@/_shared/constants';
import { useTutorialCheck } from '@/_shared/hooks';
import { useDialog } from '@/_shared/hooks/useDialog';

export const TutorialAdmin: FC = () => {
  const t = useTranslations('trainingHardSkills.tutorial.admin.slides');
  const { openDialog: openDialogTutorial } = useDialog('trainingHardSkillsAdminTutorial');
  const { hasAlreadySeenTutorial } = useTutorialCheck();

  const slides = [
    {
      title: t('slide1.title'),
      description: t('slide1.description'),
      assetName: 'tutorialHardSkillsAdminSlide1',
    },
    {
      title: t('slide2.title'),
      description: t('slide2.description'),
      assetName: 'tutorialHardSkillsAdminSlide2',
    },
    {
      title: t('slide3.title'),
      description: t('slide3.description'),
      assetName: 'tutorialHardSkillsAdminSlide3',
    },
  ];

  useEffect(() => {
    if (!hasAlreadySeenTutorial(TutorialKeys.TrainingHardSkillsAdmin)) {
      openDialogTutorial();
    }
  }, [hasAlreadySeenTutorial, openDialogTutorial]);

  return (
    <TutorialDialog
      translationsKey='trainingHardSkills.tutorial.admin'
      dialogKey='trainingHardSkillsAdminTutorial'
      slides={slides}
    />
  );
};
